var React = require('react');

function Up (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"fill":"none","stroke":"#FFFFFF","strokeMiterlimit":"10","points":"0.354,11.261 10.708,0.906 10.908,0.707 21.263,11.062 "}));
}

Up.defaultProps = {"version":"1.1","id":"圖層_1","x":"0px","y":"0px","width":"21.616px","height":"11.615px","viewBox":"0 0 21.616 11.615","enableBackground":"new 0 0 21.616 11.615","xmlSpace":"preserve"};

module.exports = Up;

Up.default = Up;
